import { render, staticRenderFns } from "./SellersSalesList.vue?vue&type=template&id=bafc95c8"
import script from "./SellersSalesList.vue?vue&type=script&lang=js"
export * from "./SellersSalesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports